import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Icon } from "../lib/Icon";
import { ErrorNote, Loading, Page } from "./common";

export function Automations() {
  const { data, isLoading, error } = useQuery({ queryKey: ["automations"], queryFn: api.automations });
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorNote error={error} />;

  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Automations & SLA</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Response targets, CSAT, and the rules that run the queue</div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 16 }}>
        {/* SLA targets */}
        <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
          <div style={{ padding: "15px 18px 10px", fontSize: 15, fontWeight: 600 }}>Response targets</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", padding: "6px 18px", fontSize: 10.5, fontWeight: 600, letterSpacing: ".8px", textTransform: "uppercase", color: "#a8aca6", borderTop: "1px solid #f4f3ee" }}>
            <span>Priority</span><span>1st reply</span><span>Resolve</span><span>Coverage</span>
          </div>
          {data.sla.map((s) => (
            <div key={s.priority} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", alignItems: "center", padding: "10px 18px", fontSize: 12.5, borderTop: "1px solid #f4f3ee" }}>
              <span style={{ fontWeight: 600 }}>{s.priority}</span>
              <span style={{ fontFamily: "'Space Mono',monospace" }}>{s.firstReply}</span>
              <span style={{ fontFamily: "'Space Mono',monospace" }}>{s.resolve}</span>
              <span style={{ color: "#8a8e88" }}>{s.coverage}</span>
            </div>
          ))}
        </div>

        {/* CSAT */}
        <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "15px 18px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <h2 style={{ margin: 0, fontSize: 15, fontWeight: 600, flex: 1 }}>CSAT</h2>
            <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 22, fontWeight: 600, color: "#1f8a5b" }}>{data.csat.current.avg}</span>
          </div>
          <div style={{ fontSize: 12, color: "#8a8e88" }}>{data.csat.current.responses} responses · {data.csat.current.period}</div>
          <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 6 }}>
            {data.csat.triggers.map(([when, how]) => (
              <div key={when} style={{ display: "flex", justifyContent: "space-between", fontSize: 12.5, padding: "5px 0", borderTop: "1px solid #f4f3ee" }}>
                <span>{when}</span><span style={{ color: "#8a8e88" }}>{how}</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 10, fontSize: 12, color: "#4a504a", fontStyle: "italic" }}>{data.csat.lowScore}</div>
        </div>
      </div>

      {/* Automation rules */}
      <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
        <div style={{ padding: "15px 18px 10px", fontSize: 15, fontWeight: 600 }}>Automation rules</div>
        {data.automations.map((a) => (
          <div key={a.name} style={{ display: "flex", alignItems: "center", gap: 12, padding: "11px 18px", borderTop: "1px solid #f4f3ee" }}>
            <span style={{ width: 34, height: 20, borderRadius: 999, background: a.on ? "#e8f4ee" : "#f0efe9", display: "flex", alignItems: "center", padding: "0 2px", justifyContent: a.on ? "flex-end" : "flex-start", flex: "none" }}>
              <span style={{ width: 16, height: 16, borderRadius: "50%", background: a.on ? "#1f8a5b" : "#bcbfba" }} />
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{a.name}</div>
              <div style={{ fontSize: 11.5, color: "#8a8e88" }}>
                <span style={{ fontFamily: "'Space Mono',monospace" }}>when</span> {a.trigger} · <span style={{ fontFamily: "'Space Mono',monospace" }}>do</span> {a.action}
              </div>
            </div>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, color: "#8a8e88", flex: "none" }}>
              <Icon name="activity" size={12} color="#8a8e88" /><span style={{ fontFamily: "'Space Mono',monospace" }}>{a.runs}</span>
            </span>
          </div>
        ))}
      </div>
    </Page>
  );
}
